import { createSlice } from "@reduxjs/toolkit";
import { IStudentAccountDetailSlice } from "../../../models/student/studentAccountsDetails";

const InitialStudentAccountDetails: IStudentAccountDetailSlice = {
    accountDetail: undefined,
  };
  
  const studentAccountDetailSlice = createSlice({
    name: "studentAccountDetailSlice",
    initialState: InitialStudentAccountDetails,
    reducers: {
      setStudentAccountDetail: (state, action: { payload: any }) => {
        state.accountDetail = action.payload;
      },
    },
  });
  
  export const { setStudentAccountDetail } = studentAccountDetailSlice.actions;
  
  
  const studentAccountDetailReducer = studentAccountDetailSlice.reducer;
  
  export type studentCourceDetailState = ReturnType<typeof studentAccountDetailReducer>;
  
  export default studentAccountDetailReducer;
  
  
  
  